import * as amplitude from '@amplitude/analytics-browser';

export function captureAmplitudeEvent(eventName: string, eventProperties?: {} | null) {
	amplitude?.track(eventName, eventProperties);
}
